<template>
	<div class="row row-fluid">
		<form class="form-admin" @submit="update">
			<div class="form-group">
				<label for="InputName">Nombre</label>
				<input type="text" class="form-control" id="InputName" v-model="render_user.name" >
			</div>
			<div class="form-group">
				<label for="InputLastName">Apellidos</label>
				<input type="text" class="form-control" id="InputLastName" v-model="render_user.last_name">
			</div>
			<div class="form-group">
				<label for="InputPhone">Teléfono</label>
				<input type="text" class="form-control" id="InputPhone" v-model="render_user.phone">
			</div>
			<div class="form-group">
				<label for="InputBirthday">Fecha de cumpleaños</label>
				<input type="date" class="form-control" v-model="render_user.birthday">
			</div>
			<!-- <div class="form-group">
				<label for="InputEmail1">Email</label>
				<input type="email" class="form-control" id="InputEmail1" v-model="render_user.email">
			</div> -->
			
			<div class="form-group" style="padding-right: 0px;">
			    <div class="custom-checkbox">
			        <input type="checkbox" id="cb1" v-model="render_user.is_wholesaler_boolean">
			        <label for="cb1">Empresa</label>
		      	</div>
		    </div>

			<div class="wholesaler" v-if="render_user.is_wholesaler_boolean">
				<div class="form-group">
					<div class="form-group">
						<p class="legend-custom">Información de la empresa</p>
					</div>
					<div class="form-group">
						<label for="InputNameEnterprise">Nombre de la Empresa</label>
						<input type="text" class="form-control" id="InputNameEnterprise">
					</div>

					<div class="form-group">
						<label for="InputName">Nombre del representante</label>
						<input type="text" class="form-control" id="InputName">
					</div>
					<div class="form-group">
						<label for="InputType">Tipo de Negocio</label>
						<input type="text" class="form-control" id="InputType">
					</div>
				</div>
				<div class="form-group">
					<div class="form-group">
						<p class="legend-custom">Verificación de la empresa</p>
					</div>
					<div class="form-group">
						<label for="InputLocation">Ubicación de la empresa</label>
						<input type="text" class="form-control" id="InputLocation">
					</div>
					<div class="form-group">
						<label for="InputRFC">RFC</label>
						<input type="text" class="form-control" id="InputRFC">
					</div>
				</div>
				<div class="form-group">
					<div class="form-group">
						<p class="legend-custom">Datos de Facturación</p>
					</div>
					<div class="form-group">
						<label for="InputName">Nombre o razón social</label>
						<input type="text" class="form-control" id="InputName">
					</div>
					<div class="form-group">
						<label for="InputStreet">Calle</label>
						<input type="text" class="form-control" id="InputStreet">
					</div>
					<div class="form-group">
						<label for="InputExt">N° Ext.</label>
						<input type="text" class="form-control" id="InputExt">
					</div>
					<div class="form-group">
						<label for="InputInt">N° Int.</label>
						<input type="text" class="form-control" id="InputInt">
					</div>
					<div class="form-group">
						<label for="InputSuburb">Colonia</label>
						<input type="text" class="form-control" id="InputSuburb">
					</div>
					<div class="form-group">
						<label for="InputZC">C.P.</label>
						<input type="text" class="form-control" id="InputZC">
					</div>
					<div class="form-group">
						<label for="InputCity">Ciudad</label>
						<input type="text" class="form-control" id="InputCity">
					</div>
					<div class="form-group">
						<label for="InputState">Estado</label>
						<input type="text" class="form-control" id="InputEstado">
					</div>
					<div class="form-group">
						<label for="InputCountry">País</label>
						<input type="text" class="form-control" id="InputPaís">
					</div>
					<div class="form-group">
						<label for="InputPhone2">Teléfono</label>
						<input type="text" class="form-control" id="InputPhone2">
					</div>
					<div class="form-group">
						<label for="InputEmail2">Email</label>
						<input type="text" class="form-control" id="InputEmail2">
					</div>
				</div>
			</div>
			<div class="form-group">
				<button type="submit" class="btn btn-black btn-lg">Guardar</button>
			</div>
		</form>
	</div>
</template>

<style scoped>
	.legend-custom{
		padding-left: 0;
	}
	.custom-checkbox > [type="checkbox"]:not(:checked) + label:before,
	.custom-checkbox > [type="checkbox"]:checked + label:before, 
	.custom-checkbox > [type="checkbox"]:checked:focus + label:before,
	.custom-checkbox > [type="checkbox"]:not(:checked):focus + label:before,
	.custom-checkbox > [type="checkbox"]:disabled:not(:checked) + label:before,
	.custom-checkbox > [type="checkbox"]:disabled:checked + label:before,
	.custom-checkbox > label:hover:before,
	.custom-checkbox > [type="checkbox"]:disabled:not(:checked) + label:hover:before,
	.custom-checkbox > [type="checkbox"]:disabled:checked + label:hover:before{
		border: 0.5px solid #979797 !important;
	}
</style>

<script>
import { setProfileUser, updateUser } from '../../store/actions';
import { router } from '../../routes/routes';

export default{
	// ------ DATA ------

	data() {
		return {};
	},

	// ------ VUEX ------

	vuex: {
		getters: {
			user: state => state.current_user,
			user_profile: state => state.user_profile
		},
		actions: {
			setProfileUser,
			updateUser
		}
	},

	// ------ RENDER ------

	computed: {
		render_user() {
			return this.user_profile;
		},

		render_is_wholesaler() {
			if (this.user_profile.is_wholesaler == '1') {
				this.user_profile.is_wholesaler_boolean = true;
			} else {
				this.user_profile.is_wholesaler_boolean = false;
			}
		}
	},

	// ------ METHODS ------

	methods: {
		update(e) {
			e.preventDefault();
			// Wrap the user info for don't send all
			// the info, only the neccesary.
			let form = this.user_profile;

			delete form.billing_infos;
			delete form.favorites;
			delete form.purchase_orders;
			delete form.ratings;
			delete form.shopping_cart;

			this.updateUser(this.user, form);
		},

		getUser(id) {
			let user = null;
			// If the user is not loaded, load the token from,
			// local storage.
			if (this.user.api_token) {
				user = this.user;
			} else {
				user = JSON.parse(localStorage.getItem('lasddi'));
			}

			this.setProfileUser(user, id);
		},

		changeUser() {
			router.afterEach(transition => {
				if (this.$route.name == 'admin_users_form') {
					this.getUser(this.$route.params.id);
				}
			});
		}
	},

	// ------ READY ------

	ready() {
		this.getUser(this.$route.params.id);
		this.changeUser()
	}
}
</script>


// WEBPACK FOOTER //
// Admin-form.vue?54c048de